import { useState, useContext } from "react";
import SettingsContext from "../../context/SettingsContext";
import { URL_CONFIG } from "../../config/urlConfig";

export const useDashboardLayoutData = () => {
  const themeSeeting = useContext(SettingsContext);

  const [isSidebarOpen, setSidebarOpen] = useState(URL_CONFIG.SHOW_SIDEBAR);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return {
    themeSeeting,
    isSidebarOpen,
    setSidebarOpen,
    isMobileNavOpen,
    setMobileNavOpen,
  };
};
